import { useEffect } from 'react';
import { useSyncIssuesOnMount } from 'hooks/useSyncIssuesOnMount';
import { useProjectId } from 'store/project';
import { useFinancialDataStore } from '../store';

/**
 * Keeps the financial data of the selected project while mounted: opens it
 * for the project (data of another project is dropped) and reads it again
 * after issue changes.
 */
export function useFinancialDataInitializer(): void {
  const { open, reset, subscribeToChannelMessages } = useFinancialDataStore.use.actions();
  const projectId = useProjectId();

  useSyncIssuesOnMount();

  useEffect(() => subscribeToChannelMessages(), [subscribeToChannelMessages]);

  useEffect(() => {
    if (projectId) {
      void open(projectId);
    } else {
      reset();
    }
  }, [projectId, open, reset]);
}
